import { Fragment, useEffect, useRef, useMemo, useState } from 'react'
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
// import download from 'downloadjs';
// import axios from 'axios';
import numeral from 'numeral';

import Backdrop from '../Backdrop/Backdrop';
import Loader from '../Loader/Loader';
import Modal from '../Modal/Modal.jsx';
import AuthButtons from "../UI/AuthButtons.jsx";


import { useStore } from '../../hook-store/store';
// import { convert } from '../../utils/video-to-audio-utils/video-to-audio-utils';
import { uploadLargeFileForProcess } from '../../utils/large-file-upload-utils/large-file-upload-utils.js';
import { marks } from '../../utils/marks';

import { 
  TEXTAUDIOTOOLSNODE_URL,
  loginPageLink,
  signupPageLink,
 } from '../../App.js';

import './VideoToAudio.css';



function VideoToMp4Action(props) {
  const {
    videoToAudioConfig,
    selectedVideoFile,
    // selectedVideoDuration,
    setConvertedVideoFile,
    uploadApp,
  } = props;

  const [t] = useTranslation("translation");

  // const hiddenFileSelect = useRef(null);

  const [store, dispatch] = useStore();
  const { 
    isAuth,
   } = store.uiStore;
  const { 
      usageBasedConfig,
      usageBasedSubscription,
      usageBasedValidMethod,
      usageBasedPrice,
  } = store.stripeData;
  // const { mlSpeechText } = store.mlSpeechStore;

  const [isLoading, setIsLoading] = useState(false);





  const convertVideoToMp4V2 = async (url, path, token, uploadFile, chunkSize) => {
      try {
        setIsLoading(true);
        // throw new Error('error-error')

        let priceId;

        if (usageBasedPrice) {
          priceId = usageBasedPrice.id;
        }

        const dataForProcess = {
          uploadApp: uploadApp, 
        };

        const response = await uploadLargeFileForProcess(
          TEXTAUDIOTOOLSNODE_URL,
          `/video-to-audio/video-file-to-mp4-file2`,
          localStorage.getItem('token'),
          uploadFile,
          chunkSize,
          localStorage.getItem('customerId'),
          priceId,
          dataForProcess,
        );

        console.log(response);

        if (!response.ok) {
          throw new Error('error occured');
        }

        // 1. Get the total file size from the Content-Length header
        const contentLength = response.headers.get('content-length');
        const totalBytes = contentLength ? parseInt(contentLength, 10) : 0;

        // console.log('contentLength, totalBytes', contentLength, totalBytes);

        // 2. Access the response body stream reader
        const reader = response.body.getReader();
        const chunks = [];
        let loadedBytes = 0;

        // 3. Read the stream chunk by chunk
        while (true) {
          const { done, value } = await reader.read();

          if (done) break; // Stream is finished

          chunks.push(value);
          loadedBytes += value.length;
          // console.log('loadedBytes', loadedBytes);

          // 4. Calculate and update progress percentage
          if (totalBytes > 0) {
            const percentCompleted = Math.round((loadedBytes * 100) / totalBytes);
            const timeList = [10, 25, 50, 75, 100];
            
            const isInTimeList = timeList.find(element => {
              return element === percentCompleted;
            });

            if (isInTimeList) {
              // console.log(percentCompleted);
              dispatch('SHOW_NOTIFICATION', {
                status: '',
                title: `${t('audioTranscriber49', 'downloading file')}... ${percentCompleted}%`,
                message: '',
              });
            }
          }
        }

        const blob = new Blob(chunks, { type: 'application/octet-stream' });




        // const blob = await response.blob();

        const file = new File([blob], `converted-${Date.now()}.mp4`, {
          type: 'video/mp4'
        });

        if (file) {
          setConvertedVideoFile(file);
        }
        
        // setIsLoading(false);


        dispatch('SHOW_NOTIFICATION', {
          status: '',
          title: `${t('audioTranscriber45', 'file processing')} ${t('audioTranscriber46', 'success')}`,
          message: '',
        });

        setTimeout(() => {
          dispatch('CLEAR_NOTIFICATION');
        },1000 * 10);


        setIsLoading(false);

      } catch(err) {
        console.log(err);
        setIsLoading(false);

        dispatch('SHOW_NOTIFICATION', {
          status: 'error',
          title: `${t('audioTranscriber45', 'file processing')} ${t('audioTranscriber48', 'failed')}`,
          message: '',
        });
      }
    };




  let isActionButtonDisabled = true;
  // let uploadFile;

  if (isAuth && selectedVideoFile) {
    isActionButtonDisabled = false;
  }

  // if (uploadFileType === 'converted') {
  //   uploadFile = convertedVideoFile;
  // };

  // if (uploadFileType === 'input') {
  //   uploadFile = selectedVideoFile;
  // };


    let isUsageBased = false;
    let isUsageBasedOk = true;
    let ubbUnit = 0;
    let videoToMp4Config;
    let maxFreeSize;
    const fileSize = selectedVideoFile && selectedVideoFile.size;

    if (videoToAudioConfig && videoToAudioConfig.videoToMp4Config) {
      videoToMp4Config = videoToAudioConfig.videoToMp4Config;
      maxFreeSize = videoToMp4Config.maxFreeSize;
    }

    // if (selectedVideoFile && selectedVideoFile.size > 0) {
    //   fileSize = selectedVideoFile.size;
    // }
    

    if (videoToMp4Config && fileSize > maxFreeSize) {

      console.log('fileSize', fileSize, maxFreeSize)

      isUsageBased = true;

      if (usageBasedConfig) {
        const billSize = fileSize - maxFreeSize;
        const baseUnit = usageBasedConfig.videoToMp4Unit;
        //// 0.1MB unit
        console.log('billSize/10**6', billSize/10**6)
        console.log('Math.ceil((billSize/10**6) * 10)', Math.ceil((billSize/10**6) * 10))
        const unitFactor = Math.ceil((billSize/10**6) * 10);
        console.log('unitFactor', unitFactor);

        ubbUnit = Math.round(baseUnit*unitFactor);
        console.log('totalUnit', ubbUnit);

      }
    }

    if (isUsageBased && 
        (!isAuth || !usageBasedSubscription || !usageBasedValidMethod)
    ) {
      isUsageBasedOk = false;
      isActionButtonDisabled = true;
    }

    console.log('isUsageBased, isUsageBasedOk', isUsageBased, isUsageBasedOk);
    
  
  let videoToMp4ActionBody;

  if (selectedVideoFile) {
    videoToMp4ActionBody = (
      <div>
        <div>

          {/* <div>
            <span>
              video-to-audio-config {JSON.stringify(videoToAudioConfig)}
            </span>
          </div> */}

          {ubbUnit > 0 && (
            <div className='videoToAudioSection'>
              Unit{' '}
              <strong>
                {ubbUnit}
                {' '}
                ({(Number(usageBasedPrice.unit_amount_decimal)/100*ubbUnit).toFixed(2)} USD)
              </strong>
            </div>
          )}

          {isUsageBased && !isAuth && (
            <div>
              <div className='videoToAudioSection'>
                <strong>
                  {t('videoToAudio10', 'For large size video file, User need to enable usage based billing after login.')} 
                </strong>
                {maxFreeSize > 0 && (
                  <div>
                    ({t('audioTranscriber27', 'more than')} 
                      {' '}{Math.round(maxFreeSize/10**6)}
                      MB {' '}~0.01 USD)
                  </div>
                )}
                
              </div>
              <div className='videoToAudioSection'>
                <a href={loginPageLink}>
                  <button className="btnBase">
                    {marks.signInMrak} {t('aboutAuth06', 'Login')}
                  </button>
                </a>
                <span> or </span>
                <a href={signupPageLink}>
                  <button className="btnBase">
                    {marks.userPlusMrak} {t('aboutAuth07', 'Signup')}
                  </button>
                </a>
              </div>
            </div>
          )}

          {isUsageBased && usageBasedPrice && usageBasedConfig && maxFreeSize > 0 && (
            <div>
              <div className='videoToAudioSection'>
                <strong>
                  {t('videoToAudio11', 'Video conversion uses a lot of resources, payment is required when large video file is used.')}
                  ({t('audioTranscriber27', 'more than')} {Math.round(maxFreeSize/10**6)} MB)
                  {/* {' '}({t('audioTranscriber27', 'more than')} 
                  {' '}
                  {Math.round(maxFreeSize/10**6)} MB, 
                  {' '}(~{Number(usageBasedPrice.unit_amount_decimal)/100*usageBasedConfig.videoToMp4Unit} USD)) */}
                </strong>
              </div>
            </div>
          )}

          {isUsageBased && isAuth && !usageBasedSubscription && (
            <div className='videoToAudioSection'>
              <div>
                <strong>
                  {t('voiceGenerator19', 'Enabling usage based billing is required.')}
                </strong>
              </div>
              <Link
                to="/usage-based-billing"
              >
                <button className='btnBase'>
                  {t('voiceGenerator20', 'Go to usage based billing page')}
                </button>
              </Link>
            </div>
          )}

          {isUsageBased && isAuth && usageBasedSubscription && !usageBasedValidMethod && (
            <div className='videoToAudioSection'>
              <div>
                <strong>
                  {t('voiceGenerator21', 'Card information for payment is required.')}
                </strong>
              </div>
              <Link
                to="/usage-based-billing"
              >
                <button className='btnBase'>
                  {t('voiceGenerator20', 'Go to usage based billing page')}
                </button>
              </Link>
            </div>
          )}

          <div className='videoToAudioSection'>
           {t('videoToAudio12', ' Less than 20 MB of file is recommended, because video processing time is depend on video size.')}
          </div>

          <div className='videoToAudioSection'>
            <button className='videoToAudioActionButton'
              disabled={isLoading || isActionButtonDisabled}
              onClick={() => {
                // convertVideoToMp4(
                //   TEXTAUDIOTOOLSNODE_URL,
                //   localStorage.getItem('token'),
                //   [selectedVideoFile],
                // );

                convertVideoToMp4V2(
                  TEXTAUDIOTOOLSNODE_URL,
                  `/video-to-audio/chunk-upload-test`,
                  localStorage.getItem('token'),
                  selectedVideoFile,
                  5*10**6,
                );
              }}
            >
              Convert to MP4
            </button>
          </div>
          {!isAuth && (
            <div>
              <div className='videoToAudioSection'>
                {t('videoToAudio13', 'Login is required.')}
              </div>
              <div className='videoToAudioSection'>
                <AuthButtons />
              </div>
            </div>
          )}
        </div>
        {isLoading && (
          <div>
            <Loader />
          </div>
        )}
      </div>
    );
  }


  return (
    <Fragment>

      <div>{videoToMp4ActionBody}</div>

    </Fragment>
  )
}

export default VideoToMp4Action;